import {Link} from "react-router-dom";
import {XCol, XText, XRow, XPush} from "../../components/xui";
import {publicStyles} from "./public-layout.css";
import {cx} from "@cdx/common";
import routes from "../../routes";
import {InnerCardFall} from "../../components/CardFall";
import codecksLogoImg from "../../images/logo-color-light.svg";

export const Strip = ({size = "md", sp, children, fillParent, ...rest}) => (
  <XCol px={4} align="center" fillParent={fillParent} {...rest}>
    <XCol
      sp={sp}
      fillParent={fillParent}
      className={cx(publicStyles.strip.default, publicStyles.strip.width[size])}
    >
      {children}
    </XCol>
  </XCol>
);

const MiniNavItem = ({to, href, children}) => (
  <XText
    as={href ? "a" : Link}
    to={to}
    href={href}
    color="gray600"
    size={1}
    className={publicStyles.miniNavItem}
  >
    {children}
  </XText>
);

const Logo = () => (
  <img src={codecksLogoImg} alt="Codecks" className={publicStyles.logo} width="2048" height="512" />
);

const PublicLayout = ({children, width = "sm", ...rest}) => (
  <XCol className={publicStyles.outer}>
    <Strip size={width} bg="purpleDim" py={7} relative>
      <InnerCardFall />
      <Logo />
    </Strip>
    <Strip size={width} bg="white" py={7} fillParent {...rest}>
      {children}
    </Strip>
    <Strip size={width} bg="gray200" py={4}>
      <XRow px={3} sp={2} align="baseline">
        <MiniNavItem href="mailto:support@codecks.io" highlight>
          Feedback
        </MiniNavItem>
        <MiniNavItem href="https://www.codecks.io/faq" highlight>
          Faq
        </MiniNavItem>
        <XPush />
        <MiniNavItem href="https://www.codecks.io/imprint">Imprint</MiniNavItem>
        <MiniNavItem href="https://www.codecks.io/tos">ToS</MiniNavItem>
        <MiniNavItem href="https://www.codecks.io/privacy">Privacy</MiniNavItem>
        <MiniNavItem to={routes.releases.getUrl()}>Changelog</MiniNavItem>
      </XRow>
    </Strip>
  </XCol>
);

export default PublicLayout;
